import {useContext, useMemo} from "react";

import MessageRuleService from "../../../services/messageRule";
import {HTTPContext} from "../../contexts";

export const useMessageRuleService = () => {
    const http = useContext(HTTPContext);
    return useMemo(() => new MessageRuleService(http), [http]);
};
